import React from 'react';
import classNames from 'classnames';
import {
    Menu,
    NotificationType,
    Popup,
    PopupReference,
} from '@instinet-analytics/semantic-ui-components';
import useOnclickOutside from 'react-cool-onclickoutside';
import './BlotterContextMenu.scss';
import { useBlotterSelection } from 'widgets/blotter/BlotterPortfolioInput';
import useCopy from '@react-hook/copy';
import { useDispatchShowNotification } from 'notification/store/dispatcher';

export interface BlotterContextMenuProps {
    className?: string;
    context: PopupReference | undefined;
    open: boolean;
    onClose: () => void;
}

export function BlotterContextMenu(props: BlotterContextMenuProps) {
    const { context, onClose, open } = props;
    const { className } = props;
    const ref = useOnclickOutside(() => {
        onClose();
    });

    const { selectedOrders } = useBlotterSelection();
    const showNotification = useDispatchShowNotification();

    const { copy } = useCopy(selectedOrders.map((o) => o.orderID).join(','));

    const onClickCopySelectedOrders = () => {
        copy().then(() => {
            showNotification('Copied to clipboard', NotificationType.Info);
            onClose();
        });
    };

    const onFilterModalClick = () => {
        setTimeout(onClose);
    };

    if (selectedOrders.length === 0) {
        return <></>;
    }

    return (
        <div className={classNames('BlotterContextMenu', className)}>
            <Popup
                basic
                context={context}
                onClose={onClose}
                open={open}
                className="BlotterContextMenuPopup"
            >
                <div ref={ref} className="MenuDropdown">
                    <Menu inverted={true} vertical onClick={onFilterModalClick}>
                        <Menu.Item
                            as="a"
                            content={
                                <span>
                                    Copy Selected Order Ids (
                                    {selectedOrders.length})
                                </span>
                            }
                            disabled={selectedOrders.length === 0}
                            onClick={onClickCopySelectedOrders}
                        />
                    </Menu>
                </div>
            </Popup>
        </div>
    );
}
